import styled from 'styled-components'

export const ProductWizardResultQty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  &:not(:first-child) {
    margin-top: 24px;
  }

  &:first-child {
    margin-top: 8px;
  }
`

export const ProductWizardResultQtyLabel = styled.div`
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 500;
`

export const NoteWrap = styled.p`
  width: 250px;
  margin-top: 4px;
  margin-bottom: 0;
  font-size: 10px;
  font-weight: 400;
  text-align: center;
  line-height: 16px;
  font-style: italic;
`
